/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Meta_TitleInputs */

const en_mk_meta_title = /** @type {(inputs: Mk_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep — Plan it. Prove it. Ship it.`)
};

const id_mk_meta_title = /** @type {(inputs: Mk_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bystep — Rencanakan. Buktikan. Rilis.`)
};

/**
* | output |
* | --- |
* | "Bystep — Plan it. Prove it. Ship it." |
*
* @param {Mk_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_meta_title = /** @type {((inputs?: Mk_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_meta_title(inputs)
	return en_mk_meta_title(inputs)
});